export const heatmapConstants = {
  GET_HEATMAP_CONFIG_REQUEST: 'HEATMAP_GET_CONFIG_REQUEST',
  GET_HEATMAP_CONFIG_SUCCESS: 'HEATMAP_GET_CONFIG_SUCCESS',
  GET_HEATMAP_CONFIG_FAILURE: 'HEATMAP_GET_CONFIG_FAILURE',
  GET_HEATMAP_STATUS_REQUEST: 'HEATMAP_GET_STATUS_REQUEST',
  GET_HEATMAP_STATUS_SUCCESS: 'HEATMAP_GET_STATUS_SUCCESS',
  GET_HEATMAP_STATUS_FAILURE: 'HEATMAP_GET_STATUS_FAILURE',
};
